export default function Newsletter() {
  return (
    <>

    {/*
 <section id="subscribe">
      <div className="container" data-aos="zoom-in">
        <div className="section-header">
          <h2>Newsletter</h2>
          <p>Subscribe now for latest travel news.</p>
        </div>

        <form method="POST" action="#">
          <div className="row justify-content-center">
            <div className="col-lg-6 col-md-10 d-flex">
              <input type="text" className="form-control" placeholder="Enter your Email" />
              <button type="submit" className="ms-2">Subscribe</button>
            </div>
          </div>
        </form>

      </div>
    </section>



  <section id="support1ers" className="section-with-bg ourbookingscontact">
      <div className="container" data-aos="fade-up">
        <div className="section-header">
          <h2>Why Book With Us?</h2>
        </div>

        <div className="row no-gutters supporters-wrap clearfix" data-aos="zoom-in" data-aos-delay="100">

          <div className="col-lg-3 col-md-4 col-xs-6">
            <div className="supporter-logo">
              <img src={"../assets/img/icons/1.png"} className="img-fluid" alt="" />
              <h4 className="widget-title">EASY BOOKING</h4>
              <p>We offer easy and convenient flight bookings with attractive offers.</p>
            </div>
          </div>

          <div className="col-lg-3 col-md-4 col-xs-6">
            <div className="supporter-logo">
              <img src={"../assets/img/icons/2.png"} className="img-fluid" alt="" />
              <h4 className="widget-title">LOWEST PRICE</h4>
              <p>We ensure low rates holiday packages and on flight tickets.</p>
            </div>
          </div>

          <div className="col-lg-3 col-md-4 col-xs-6">
            <div className="supporter-logo">
              <img src={"../assets/img/icons/3.png"} className="img-fluid" alt="" />
              <h4 className="widget-title">EXCITING DEALS</h4>
              <p>Enjoy exciting deals on flights, hotels, car rental and tour packages.</p>
            </div>
          </div>
 <div className="col-lg-3 col-md-4 col-xs-6">
            <div className="supporter-logo">
              <img src={"../assets/img/icons/4.png"} className="img-fluid" alt="" />
              <h4 className="widget-title">24/7 SUPPORT</h4>
              <p>Get assistance 24/7 on any kind of travel related query.</p>
            </div>
          </div>


        </div>

      </div>

    </section>
    */}
    </>
  );
}
